export const SERVICES = [
  {
    slug: "maconnerie",
    formValue: "Maçonnerie",
    title: "Maçonnerie",
    icon: "Hammer",
    short: "Gros œuvre et second œuvre : ouvertures, reprises de structure, dalles, chapes, murs et cloisons.",
    description:
      "Travaux de gros œuvre et de second œuvre réalisés dans les règles de l'art : création et élargissement d'ouvertures, reprises de structure, dalles, chapes, murs porteurs et cloisons. Nous intervenons sur immeubles, maisons et locaux professionnels, en neuf comme en rénovation.",
    items: [
      "Ouvertures de murs porteurs avec pose d'IPN et reprises en sous-œuvre",
      "Dalles béton, chapes et ragréages",
      "Reprises de structure, fissures et scellements",
      "Montage de murs, cloisons et doublages",
      "Réfection d'escaliers, seuils et appuis de fenêtres",
    ],
    image:
      "https://images.unsplash.com/photo-1684025295367-e0c115ec7745?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
  },
  {
    slug: "etancheite",
    formValue: "Étanchéité",
    title: "Étanchéité",
    icon: "Droplets",
    short: "Toitures-terrasses, balcons, sous-sols, salles d'eau : traitement des infiltrations et remontées capillaires.",
    description:
      "Diagnostic et traitement des désordres liés à l'eau : toitures-terrasses, balcons et loggias, sous-sols, cuves, salles d'eau. Nous traitons les infiltrations et les remontées capillaires avec des solutions durables, adaptées à chaque support.",
    items: [
      "Étanchéité de toitures-terrasses et acrotères",
      "Étanchéité de balcons, loggias et terrasses accessibles",
      "Traitement des infiltrations et remontées capillaires",
      "Cuvelage de sous-sols et locaux enterrés",
      "Systèmes d'étanchéité sous carrelage (salles d'eau)",
    ],
    image:
      "https://images.unsplash.com/photo-1674485169641-bcb2bf6f1df9?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
  },
  {
    slug: "isolation",
    formValue: "Isolation",
    title: "Isolation",
    icon: "Layers",
    short: "Isolation thermique et acoustique des combles, murs et planchers pour un bâti plus performant.",
    description:
      "Amélioration de la performance énergétique et du confort acoustique du bâti : isolation des combles perdus ou aménagés, des murs par l'intérieur ou l'extérieur, des planchers bas. Chaque solution est dimensionnée selon la configuration du bâtiment.",
    items: [
      "Isolation des combles perdus et aménagés",
      "Isolation thermique des murs par l'intérieur (ITI)",
      "Isolation thermique par l'extérieur (ITE) sur devis",
      "Isolation des planchers bas et caves",
      "Traitement des ponts thermiques et isolation acoustique",
    ],
    image:
      "https://images.unsplash.com/photo-1581094288338-2314dddb7ece?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
  },
  {
    slug: "equipements-techniques",
    formValue: "Équipements techniques",
    title: "Équipements techniques",
    icon: "Wrench",
    short: "Installation et mise en service d'équipements techniques du bâtiment : ventilation, sanitaires, réseaux.",
    description:
      "Installation et mise en service des équipements techniques du bâtiment, en coordination avec les autres corps d'état : ventilation, installations sanitaires, réseaux d'évacuation et d'alimentation, équipements des parties communes.",
    items: [
      "Ventilation mécanique (VMC) et extraction",
      "Installations sanitaires et plomberie associée",
      "Réseaux d'alimentation et d'évacuation",
      "Équipements techniques des parties communes",
      "Mise en service, essais et remise des notices",
    ],
    image:
      "https://images.unsplash.com/photo-1621905252507-b35492cc74b4?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
  },
  {
    slug: "renovation",
    formValue: "Rénovation complète",
    title: "Rénovation d'immeubles et de logements",
    icon: "Building2",
    short: "Rénovation complète ou partielle d'appartements, maisons, locaux professionnels et parties communes.",
    description:
      "Rénovation complète ou partielle d'appartements, de maisons, de locaux professionnels et de parties communes d'immeubles. Un interlocuteur unique coordonne l'ensemble des travaux, du diagnostic à la finition, dans le respect du planning et du budget validés.",
    items: [
      "Rénovation complète d'appartements et de maisons",
      "Réhabilitation de parties communes (halls, cages d'escalier, caves)",
      "Rénovation de locaux professionnels et commerces",
      "Coordination des corps d'état et suivi de chantier",
      "Finitions : revêtements, peinture, menuiseries intérieures",
    ],
    image:
      "https://images.unsplash.com/photo-1692119442094-45806e38a35e?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
  },
  {
    slug: "entretien",
    formValue: "Entretien et maintenance",
    title: "Entretien et maintenance",
    icon: "ClipboardCheck",
    short: "Entretien courant, petites réparations, interventions ponctuelles et contrats pour syndics et bailleurs.",
    description:
      "Travaux d'entretien courant, petites réparations et interventions ponctuelles pour maintenir votre patrimoine en bon état. Nous proposons aux professionnels, syndics et bailleurs des contrats d'entretien sur mesure, établis sur devis.",
    items: [
      "Petites réparations et interventions ponctuelles",
      "Entretien des parties communes et des façades",
      "Reprises d'enduits, de peinture et de joints",
      "Contrats d'entretien pour syndics, bailleurs et gestionnaires",
      "Visites de contrôle et comptes rendus d'intervention",
    ],
    image:
      "https://images.unsplash.com/photo-1708058887990-18f0dcb4e8a3?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
  },
];

export const FAQ = [
  { q: "Le devis est-il vraiment gratuit ?", a: "Oui, le devis est gratuit et sans engagement. Il est valable 30 jours à compter de sa date d'émission." },
  { q: "Intervenez-vous pour les particuliers et les professionnels ?", a: "Oui, nous intervenons auprès des particuliers, des professionnels, des syndics de copropriété et des bailleurs." },
  { q: "Êtes-vous couvert par une assurance décennale ?", a: "Oui. O'RIZON 360 est couverte par une assurance responsabilité civile professionnelle et une assurance décennale. Les attestations sont fournies sur simple demande." },
  { q: "Quels sont les délais d'intervention ?", a: "Nous répondons à toute demande sous 48 heures ouvrées et planifions l'intervention selon la nature et l'ampleur des travaux." },
  { q: "Proposez-vous des contrats d'entretien pour syndics et bailleurs ?", a: "Oui, sur devis personnalisé, après visite du patrimoine concerné et définition du périmètre d'intervention." },
  { q: "Quelles garanties s'appliquent à vos travaux ?", a: "Garantie de parfait achèvement (1 an), garantie biennale de bon fonctionnement (2 ans) et garantie décennale (10 ans), conformément aux articles 1792 et suivants du Code civil." },
  { q: "Faites-vous des devis à distance ?", a: "Oui. Une visite technique peut être organisée, ou un devis établi sur la base des informations et photos que vous nous transmettez via le formulaire." },
  { q: "Quels modes de paiement acceptez-vous ?", a: "Virement bancaire et chèque. Les modalités précises (acompte, échéances, solde) sont indiquées sur chaque devis." },
  { q: "Intervenez-vous en dehors de l'Île-de-France ?", a: "Notre zone d'intervention couvre toute l'Île-de-France. Les demandes hors Île-de-France sont étudiées au cas par cas." },
  { q: "Quel taux de TVA s'applique à mes travaux ?", a: "20 % (taux normal), 10 % pour les travaux d'amélioration ou d'entretien d'un logement achevé depuis plus de 2 ans, 5,5 % pour la rénovation énergétique sous conditions. Le taux applicable est précisé sur chaque devis." },
];

export const PROJECT_TYPES = ["Rénovation complète", "Maçonnerie", "Étanchéité", "Isolation", "Équipements techniques", "Entretien et maintenance", "Autre"];
export const CLIENT_TYPES = ["Particulier", "Professionnel", "Syndic de copropriété", "Bailleur", "Autre"];
export const PROPERTY_TYPES = ["Appartement", "Maison", "Immeuble", "Local commercial", "Autre"];
export const DELAYS = ["Dès que possible", "Dans le mois", "Dans les 3 mois", "Autre"];
export const BUDGETS = ["< 5 000 €", "5 000 – 15 000 €", "15 000 – 50 000 €", "> 50 000 €", "À définir"];
export const SOURCES = ["Bouche-à-oreille", "Recherche internet", "Réseaux sociaux", "Autre"];
